import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBooleanGroupUnion: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconBooleanGroupUnion"><Path d="M9.75 2C8.7835 2 8 2.7835 8 3.75V8H3.75C2.7835 8 2 8.7835 2 9.75V20.25C2 21.2165 2.7835 22 3.75 22H14.25C15.2165 22 16 21.2165 16 20.25V16H20.25C21.2165 16 22 15.2165 22 14.25V3.75C22 2.7835 21.2165 2 20.25 2H9.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBooleanGroupUnion;
